export default theme => ({
  root: {
    justifyContent: 'space-between',
  },
  formControl: {
    margin: theme.spacing(1),
  },
});
